import type { FetchThemePageProps } from '~/types/themePage';

import { parseTemplateIdBy, parseTemplateInfoBy } from '~/utils';
import { useThemePageStore } from '~/stores/themePage';
import { ProviderSource } from '~/types/template';
import { useMemo } from 'react';

export const useTemplateIdParser = (props?: FetchThemePageProps) => {
  const themePageIdsFetched = useThemePageStore((state) => state.idsFetched);

  const variants = useMemo(() => {
    return props?.campaigns?.flatMap((campaign) => campaign.variants) || [];
  }, [props?.campaigns]);

  const parseAndPushTemplateId = (templateSuffix: string | undefined, acc: string[]) => {
    if (!templateSuffix) return;

    const templateInfo = parseTemplateInfoBy({ templateSuffix });
    if (templateInfo?.providerSource !== ProviderSource.GEMPAGESV7) return;

    const templateId = parseTemplateIdBy(templateSuffix, ProviderSource.GEMPAGESV7);
    const isFetched = templateId && themePageIdsFetched?.includes(templateId);
    if (templateId && !isFetched) {
      acc.push(templateId);
    }
  };

  const templateIdWithAsset = useMemo(() => {
    return (
      props?.assets?.templateGPV7?.reduce<string[]>((acc, asset) => {
        parseAndPushTemplateId(asset.key!, acc);
        return acc;
      }, []) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.assets?.templateGPV7]);

  const templateIdWithVariant = useMemo(() => {
    return (
      variants?.reduce<string[]>((acc, variant) => {
        parseAndPushTemplateId(variant?.templateSuffix, acc);
        return acc;
      }, []) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variants]);

  return {
    templateIdWithVariant,
    templateIdWithAsset,
  };
};
